module.exports = __webpack_public_path__ + "static/media/Converge-Funding.f963abf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/Converge-Funding.png
// module id = 438
// module chunks = 0